import React from 'react';
import { useTranslation } from 'react-i18next';

const PrivacyTermsSupport = () => {
  const { t } = useTranslation();

  return (
    <div className={'col-12 col-md-6 px-3 py-4'} style={{ minHeight: '100%' }}>
      <div className="termsAndPrivacy">
        <h4>{t('Terms of Service')}</h4>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tincidunt est eu egestas dapibus. Interdum et malesuada fames ac ante ipsum primis in faucibus. Sed molestie efficitur augue, vel tincidunt.</p>
        <br/>
        <h4>{t('Personal Data')}</h4>
        <p>of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.</p>
        <br/>
      </div>
    </div>
  );
};

export default PrivacyTermsSupport;